import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';
import Navbar from '../components/Navbar';

const TermsAndConditions = () => {
  const { t } = useTranslation('terms');
  const currentDate = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD

  return (
    <div className="min-h-screen bg-[#0C3B2E]">
      <Navbar />
      <div className="container mx-auto px-4 py-16 pt-24">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">{t('title')}</h1>
          <p className="text-white/80 mb-8">{t('lastUpdated', { date: currentDate })}</p>
          
          <div className="space-y-8 text-white/90">
            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.acceptance.title')}</h2>
              <p className="text-white/80">{t('sections.acceptance.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.workflow.title')}</h2>
              <p className="text-white/80 mb-4">{t('sections.workflow.intro')}</p>
              <ol className="list-decimal pl-6 space-y-2 text-white/80">
                {t('sections.workflow.steps', { returnObjects: true }).map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
              <p className="text-white/80 mt-4">{t('sections.workflow.closing')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.aiService.title')}</h2>
              <p className="text-white/80">{t('sections.aiService.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.payment.title')}</h2>
              <p className="text-white/80">{t('sections.payment.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.cookies.title')}</h2>
              <p className="text-white/80 mb-4">{t('sections.cookies.intro')}</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80">
                {t('sections.cookies.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <p className="text-white/80 mt-4">{t('sections.cookies.closing')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.privacy.title')}</h2>
              <p className="text-white/80 mb-4">{t('sections.privacy.intro')}</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80">
                {t('sections.privacy.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <p className="text-white/80 mt-4">{t('sections.privacy.closing')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.liability.title')}</h2>
              <p className="text-white/80 mb-4">{t('sections.liability.intro')}</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80">
                {t('sections.liability.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.newsletter.title')}</h2>
              <p className="text-white/80 mb-4">{t('sections.newsletter.intro')}</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80">
                {t('sections.newsletter.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">{t('sections.modifications.title')}</h2>
              <p className="text-white/80 mb-4">{t('sections.modifications.content')}</p>
              <p className="text-white/80">{t('sections.modifications.jurisdiction')}</p>
            </section>
            
            <section>
              <p className="text-white/80 mt-8 text-center">{t('agreement')}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;